import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { auth } from "./firebase";

const storage = getStorage(); // usa default app

console.log("STORAGE BUCKET:", storage.app.options.storageBucket);
console.log("AUTH UID:", auth.currentUser?.uid);

function storagePathFromDownloadURL(url) {
  const u = new URL(url);
  const parts = u.pathname.split("/o/");
  if (parts.length < 2) throw new Error("URL non valida (manca /o/).");
  return decodeURIComponent(parts[1]);
}

export async function uploadFile({ section, slug, file, kind }) {
  const safeName = `${Date.now()}-${file.name}`.replace(/\s+/g, "_");
  const path =
    kind === "cover"
      ? `mudif/${section}/${slug}/cover/${safeName}`
      : `mudif/${section}/${slug}/gallery/${safeName}`;

  const r = ref(storage, path);
  await uploadBytes(r, file);
  return await getDownloadURL(r);
}

export async function deleteFileByUrl(url) {
  const path = storagePathFromDownloadURL(url);
  await deleteObject(ref(storage, path));
}